import React from 'react';
import { FaTimes } from 'react-icons/fa';

const PopUp = ({ blog, handlePop }) => {
  return (
    <div className='bg-white w-10/12 sm:w-6/12 md:w-4/12 h-80 bg-contain absolute pop rounded-3xl shadow-2xl py-4 px-4'>
      <div className='flex justify-between border-b'>
        {' '}
        <p className=' text-gray-500'>Likes</p>
        <FaTimes onClick={handlePop} />
      </div>

      {blog.likes.map((item, index) => (
        <div className='flex justify-between items-center ' key={index}>
          <p className='py-1 text-gray-500 text-sm'>{item.name}</p>

          <p className=' text-xs text-gray-500'>liked post</p>
          {/* <FaThumbsUp color='#f7b950' /> */}
        </div>
      ))}
    </div>
  );
};

export default PopUp;
